/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { emailGroupsListLoadingAction, emailGroupsListUpdateAction, emailGroupsListErrorAction } from './emailGroupsListSlice'
import { emailGroupDetailsLoadingAction, emailGroupDetailsUpdateAction, emailGroupDetailsErrorAction } from './emailGroupDetailsSlice'
import * as EmailGroupsService from '../services/emailGroupsService'
import * as EmailGroupDetailsService from '../services/emailGroupDetailsService'
import * as ToggleEmailGroupService from '../services/toggleEmailGroupService'
import * as CreateEmailAlertGroupService from '../services/createEmailGroupService'
import * as DeleteEmailGroupService from '../services/deleteEmailGroupService'
import * as UpdateEmailGroupService from '../services/updateEmailGroupService'

export const fetchEmailGroups = (
  page: number,
  pageSize: number,
  sortEnabled: boolean
) => async (dispatch: any): Promise<void> => {
  dispatch(emailGroupsListLoadingAction())
  void EmailGroupsService.getEmailGroups(
    page,
    pageSize,
    sortEnabled,
    (emailGroups, httpStatus) => {
      dispatch(
        emailGroupsListUpdateAction({
          data: emailGroups.data,
          count: emailGroups.totalCount,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(emailGroupsListErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const fetchEmailGroupDetails = (
  groupId: string
) => async (dispatch: any): Promise<void> => {
  dispatch(emailGroupDetailsLoadingAction())
  void EmailGroupDetailsService.getEmailGroupDetails(
    groupId,
    (groupDetails, httpStatus) => {
      dispatch(
        emailGroupDetailsUpdateAction({
          data: groupDetails,
          httpStatus
        })
      )
    },
    (errorMessage, httpStatus) => {
      dispatch(emailGroupDetailsErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const toggleEmailGroupEnabled = (
  groupId: string,
  enabled: boolean,
  onSuccess: () => void,
  onFailure: (errorMessage: string) => void
) => async (dispatch: any): Promise<void> => {
  try {
    await ToggleEmailGroupService.toggleEmailGroupEnabled(
      groupId,
      enabled,
      () => {
        onSuccess()
      },
      (errorMessage) => {
        onFailure(errorMessage)
      }
    )
  } catch (error: unknown) {
    if (
      error !== null &&
      typeof error === 'object' &&
      Object.prototype.hasOwnProperty.call(error, 'message') &&
      typeof (error as { message?: unknown }).message === 'string'
    ) {
      onFailure((error as { message: string }).message)
    } else {
      onFailure('Unknown error')
    }
  }
}

export const createEmailAlertGroup = (
  createRequest: CreateEmailAlertGroupService.CreateEmailGroupRequest,
  onSuccess: (response: any, httpStatus: number) => void,
  onFailure: (errorMessage: string, httpStatus: number) => void
) => async (dispatch: any) => {
  await CreateEmailAlertGroupService.createEmailGroup(
    createRequest,
    (response, httpStatus) => {
      onSuccess(response, httpStatus)
    },
    (errorMessage, httpStatus) => {
      onFailure(errorMessage, httpStatus)
    }
  )
}

export const updateEmailAlertGroup = (
  groupId: string,
  updateRequest: UpdateEmailGroupService.UpdateEmailGroupRequest,
  onSuccess: (response: any, httpStatus: number) => void,
  onFailure: (errorMessage: string, httpStatus: number) => void
) => async (dispatch: any) => {
  await UpdateEmailGroupService.updateEmailGroup(
    groupId,
    updateRequest,
    (response, httpStatus) => {
      onSuccess(response, httpStatus)
    },
    (errorMessage, httpStatus) => {
      onFailure(errorMessage, httpStatus)
    }
  )
}

export const deleteEmailGroup = (
  groupId: string,
  onSuccess: (response: any, httpStatus: number) => void,
  onFailure: (errorMessage: string, httpStatus: number) => void
) => async (dispatch: any) => {
  await DeleteEmailGroupService.deleteEmailGroup(
    groupId,
    (response, httpStatus) => {
      onSuccess(response, httpStatus)
    },
    (errorMessage, httpStatus) => {
      onFailure(errorMessage, httpStatus)
    }
  )
}
